import { Component, OnInit, OnDestroy, ɵCompiler_compileModuleSync__POST_R3__ } from '@angular/core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import { ReportsService } from 'src/app/shared/services/reports.service';
import { Filter } from 'src/app/shared/models/filter.model';
import { Observable, Subscription } from 'rxjs';
import { FormGroup, FormControl, FormsModule } from '@angular/forms';
import { RoleSendService } from 'src/app/shared/services/role-send.service';
import { BranchOfficeService } from 'src/app/shared/services/admin-services/branch-office.service';
import { UserService } from 'src/app/shared/services/admin-services/user.service';
import { Lookup } from 'src/app/shared/models/admin-models/lookup.model';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-offers-report',
  templateUrl: './offers-report.component.html',
  styleUrls: ['./offers-report.component.sass']
})
export class OffersReportComponent implements OnInit, OnDestroy {
  faSearch = faSearch;
  faCalendarAlt = faCalendarAlt

  roleService: Subscription;
  roleType: String = '';

  filter: Filter = new Filter({ Filter: {} })

  reports;
  page = 1;
  pageSize = 10;
  total;

  filterDate = new Date();
  filterForm = new FormGroup({
    offerRadio: new FormControl('1'),
    dateFrom: new FormControl(''),
    dateTo: new FormControl(''),
    offerStatuses: new FormControl([
      { id: 1, name: 'U procesu potpisivanja' },
      { id: 2, name: 'Čeka potvrdu' },
      { id: 3, name: 'Potvrđeno' },
      { id: 4, name: 'Poslata' },
      { id: 5, name: 'Primljena' },
      { id: 7, name: 'U obradi' },
      { id: 8, name: 'Reklamacija' },
      { id: 11, name: 'Aktivna' }
    ]),
    settlement: new FormControl(''),
    agentCode: new FormControl(''),
    offerType: new FormControl(''),
    paymentTypeID: new FormControl(''),
    productTypeID: new FormControl(''),
    paymentFrequency: new FormControl(''),
    appointmentSource: new FormControl(''),
    agency: new FormControl(''),
    userID: new FormControl(''),
    branchOfficeID: new FormControl(''),
    signedRemotely: new FormControl('')
  })

  dropdownSettings: IDropdownSettings = {};
  offerStatusesArray: { id: Number, name: String }[] = [
    {
      id: 0,
      name: 'U pripremi'
    },
    {
      id: 1,
      name: 'U procesu potpisivanja'
    },
    {
      id: 2,
      name: 'Čeka potvrdu'
    },
    {
      id: 3,
      name: 'Potvrđeno'
    },
    {
      id: 4,
      name: 'Poslata'
    },
    {
      id: 5,
      name: 'Primljena'
    },
    {
      id: 7,
      name: 'U obradi'
    },
    {
      id: 8,
      name: 'Reklamacija'
    },
    {
      id: 9,
      name: 'Poništena'
    },
    {
      id: 10,
      name: 'Odbijena'
    },
    {
      id: 11,
      name: 'Aktivna'
    }
  ]

  constructor(private reportsService: ReportsService, private roleSendService: RoleSendService, private branchOfficeService: BranchOfficeService, private userService: UserService) {
    this.roleService = this.roleSendService.info$.subscribe(
      (res: String) => {
        this.roleType = res;
      }
    )
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      allowSearchFilter: true,
      enableCheckAll: true,
      selectAllText: 'Selektuj sve',
      unSelectAllText: 'Odselektuj sve'
    };
  }

  ngOnInit() {
    this.getAllBranchOffices();
    this.getBoxViewUsers();

    // console.log(this.filterDate)
    // console.log(this.filterDate.getMonth())
    this.filterDate.setMonth(this.filterDate.getMonth() + 2);
    this.filterDate.setDate(1);
    // console.log(this.filterDate)
    // console.log(this.filterDate.getDate())
    // console.log(this.filterDate.getMonth())
    // console.log(this.filterDate.getFullYear())
    this.filterForm.get('dateFrom').setValue({ year: this.filterDate.getMonth() == 0 ? this.filterDate.getFullYear() - 1 : this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 0 ? 12 : this.filterDate.getMonth(), day: this.filterDate.getDate() })
    this.filterForm.get('dateTo').setValue({ year: this.filterDate.getMonth() == 0 ? this.filterDate.getFullYear() - 1 : this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 0 ? 12 : this.filterDate.getMonth(), day: this.filterDate.getDate() })

    this.getReports();
  }

  ngOnDestroy() {
    this.roleService.unsubscribe();
  }

  getReports() {
    this.filter.data.Filter = { OfferStatuses: [] };
    
    if (this.filterForm.value.offerRadio == '0') {
      this.filter.data.Filter.DateScheduledFrom = this.filterForm.value.dateFrom.year + '-' + this.filterForm.value.dateFrom.month + '-' + this.filterForm.value.dateFrom.day + " 00:00:00"
      this.filter.data.Filter.DateScheduledTo = this.filterForm.value.dateTo.year + '-' + this.filterForm.value.dateTo.month + '-' + this.filterForm.value.dateTo.day + " 23:59:00"
    }
    if (this.filterForm.value.offerRadio == '1') {
      this.filter.data.Filter.DateInsuranceStartFrom = this.filterForm.value.dateFrom.year + '-' + this.filterForm.value.dateFrom.month + '-' + this.filterForm.value.dateFrom.day + " 00:00:00"
      this.filter.data.Filter.DateInsuranceStartTo = this.filterForm.value.dateTo.year + '-' + this.filterForm.value.dateTo.month + '-' + this.filterForm.value.dateTo.day + " 23:59:00"
    }
    if (this.filterForm.value.offerStatuses.length > 0)
      for (let i = 0; i < this.filterForm.value.offerStatuses.length; i++)
        this.filter.data.Filter.OfferStatuses.push(this.filterForm.value.offerStatuses[i].id)
    if (this.filterForm.value.branchOfficeID)
      this.filter.data.Filter.BranchOfficeAppointmentID = this.filterForm.value.branchOfficeID
    if (this.filterForm.value.userID)
      this.filter.data.Filter.UserID = this.filterForm.value.userID
    if (this.filterForm.value.agentCode)
      this.filter.data.Filter.AgentCode = this.filterForm.value.agentCode
    if (this.filterForm.value.settlement)
      this.filter.data.Filter.Settlement = this.filterForm.value.settlement
    if (this.filterForm.value.paymentTypeID)
      this.filter.data.Filter.PaymentType = this.filterForm.value.paymentTypeID
    if (this.filterForm.value.productTypeID)
      this.filter.data.Filter.ProductType = this.filterForm.value.productTypeID
    if (this.filterForm.value.paymentFrequency)
      this.filter.data.Filter.PaymentFrequency = this.filterForm.value.paymentFrequency
    if (this.filterForm.value.appointmentSource)
      this.filter.data.Filter.AppointmentSource = this.filterForm.value.appointmentSource
    if (this.filterForm.value.offerType)
      this.filter.data.Filter.OfferType = this.filterForm.value.offerType
    if (this.filterForm.value.agency == '1')
      this.filter.data.Filter.Agency = true
    if (this.filterForm.value.agency == '0')
      this.filter.data.Filter.Agency = false
    if (this.filterForm.value.signedRemotely == '1')
      this.filter.data.Filter.SignedRemotely = true
    if (this.filterForm.value.signedRemotely == '0')
      this.filter.data.Filter.SignedRemotely = false

    console.log(this.filter)
    // this.reports = this.reportsService.offerReport(this.filter);
    this.reportsService.offerReport(this.filter)
      .subscribe(
        x => {
          // console.log(x)
          this.reports = x;
          this.total = x.length;
        }
      )
  }

  exportExcelReport() {
    this.filter.data.Filter = { OfferStatuses: [] };
    if (this.filterForm.value.offerRadio == 0) {
      this.filter.data.Filter.DateScheduledFrom = this.filterForm.value.dateFrom.year + '-' + this.filterForm.value.dateFrom.month + '-' + this.filterForm.value.dateFrom.day + " 00:00:00"
      this.filter.data.Filter.DateScheduledTo = this.filterForm.value.dateTo.year + '-' + this.filterForm.value.dateTo.month + '-' + this.filterForm.value.dateTo.day + " 23:59:00"
    }
    if (this.filterForm.value.offerRadio == 1) {
      this.filter.data.Filter.DateInsuranceStartFrom = this.filterForm.value.dateFrom.year + '-' + this.filterForm.value.dateFrom.month + '-' + this.filterForm.value.dateFrom.day + " 00:00:00"
      this.filter.data.Filter.DateInsuranceStartTo = this.filterForm.value.dateTo.year + '-' + this.filterForm.value.dateTo.month + '-' + this.filterForm.value.dateTo.day + " 23:59:00"
    }
    if (this.filterForm.value.offerStatuses.length > 0)
      for (let i = 0; i < this.filterForm.value.offerStatuses.length; i++)
        this.filter.data.Filter.OfferStatuses.push(this.filterForm.value.offerStatuses[i].id)
    if (this.filterForm.value.branchOfficeID)
      this.filter.data.Filter.BranchOfficeAppointmentID = this.filterForm.value.branchOfficeID
    if (this.filterForm.value.userID)
      this.filter.data.Filter.UserID = this.filterForm.value.userID
    if (this.filterForm.value.agentCode)
      this.filter.data.Filter.AgentCode = this.filterForm.value.agentCode
    if (this.filterForm.value.settlement)
      this.filter.data.Filter.Settlement = this.filterForm.value.settlement
    if (this.filterForm.value.paymentTypeID)
      this.filter.data.Filter.PaymentType = this.filterForm.value.paymentTypeID
    if (this.filterForm.value.productTypeID)
      this.filter.data.Filter.ProductType = this.filterForm.value.productTypeID
    if (this.filterForm.value.paymentFrequency)
      this.filter.data.Filter.PaymentFrequency = this.filterForm.value.paymentFrequency
    if (this.filterForm.value.appointmentSource)
      this.filter.data.Filter.AppointmentSource = this.filterForm.value.appointmentSource
    if (this.filterForm.value.offerType)
      this.filter.data.Filter.OfferType = this.filterForm.value.offerType
    if (this.filterForm.value.agency == '1')
      this.filter.data.Filter.Agency = true
    if (this.filterForm.value.agency == '0')
      this.filter.data.Filter.Agency = false
    if (this.filterForm.value.signedRemotely == '1')
      this.filter.data.Filter.SignedRemotely = true
    if (this.filterForm.value.signedRemotely == '0')
      this.filter.data.Filter.SignedRemotely = false

    this.reportsService.offerExcelReport(this.filter)
      .subscribe(
        (x: any) => {
          console.log(x)
          let blob = new Blob([x.body], { type: 'application/octet-stream' });
          var contentDispositionHeader = x.headers.get('Content-Disposition');
          var filename = contentDispositionHeader.split(';')[1].trim().split('=')[1].split('"')[1];
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        }
      )
  }

  changeRadioFilter(number) {
    if (number == 0) {
      this.filterDate = new Date();
      this.filterDate.setMonth(this.filterDate.getMonth() + 1);
      this.filterForm.get('dateFrom').setValue({ year: this.filterDate.getMonth() == 0 ? this.filterDate.getFullYear() - 1 : this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 0 ? 12 : this.filterDate.getMonth(), day: this.filterDate.getDate() })
      this.filterForm.get('dateTo').setValue({ year: this.filterDate.getMonth() == 0 ? this.filterDate.getFullYear() - 1 : this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 0 ? 12 : this.filterDate.getMonth(), day: this.filterDate.getDate() })
    } else {
      this.filterDate = new Date();
      this.filterDate.setDate(1);
      this.filterDate.setMonth(this.filterDate.getMonth() + 2);
      this.filterForm.get('dateFrom').setValue({ year: this.filterDate.getMonth() == 0 ? this.filterDate.getFullYear() - 1 : this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 0 ? 12 : this.filterDate.getMonth(), day: this.filterDate.getDate() })
      this.filterForm.get('dateTo').setValue({ year: this.filterDate.getMonth() == 0 ? this.filterDate.getFullYear() - 1 : this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 0 ? 12 : this.filterDate.getMonth(), day: this.filterDate.getDate() })
    }
    this.getReports();
  }

  brankOfficeArray: Observable<Lookup[]>
  getAllBranchOffices() {
    this.brankOfficeArray = this.branchOfficeService.boxView();
  }

  boxUserArray: Observable<any>;
  getBoxViewUsers() {
    let fil = new Filter({ Top: null, Page: null, Filter: {}, Sort: { SortBy: 'Active', Direction: 1 } })
    if (this.filterForm.value.branchOfficeID)
      fil.data.Filter.BranchOfficeID = this.filterForm.value.branchOfficeID
    this.boxUserArray = this.userService.boxView(fil)
  }

  clearFilters() {
    this.filterForm.reset({ dateFrom: { year: this.filterForm.value.dateFrom.year, month: this.filterForm.value.dateFrom.month, day: this.filterForm.value.dateFrom.day }, dateTo: { year: this.filterForm.value.dateTo.year, month: this.filterForm.value.dateTo.month, day: this.filterForm.value.dateTo.day }, offerRadio: this.filterForm.value.offerRadio, branchOfficeID: '', userID: '', paymentTypeID: '', productTypeID: '', paymentFrequency: '', appointmentSource: '', offerType: '', offerStatuses: [{ id: 1, name: 'U procesu potpisivanja' }, { id: 2, name: 'Čeka potvrdu' }, { id: 3, name: 'Potvrđeno' }, { id: 4, name: 'Poslata' }, { id: 5, name: 'Primljena' }, { id: 7, name: 'U obradi' }, { id: 8, name: 'Reklamacija' }, { id: 11, name: 'Aktivna' }] })
    this.getReports();
  }

}
